import { htmlEl } from './stationDisplays.js';

/** Title bar with the shared credit balance on the right. */
export const createFacilityHead = (title: string) => {
  const root = htmlEl('header', 'fc-head');
  root.append(htmlEl('span', 'fc-title', title));
  const credits = htmlEl('span', 'fc-credits');
  const amount = htmlEl('b', 'fc-credits-amount', '0');
  credits.append(htmlEl('span', 'fc-credits-label', 'CREDITS'), amount, htmlEl('span', 'fc-credits-unit', 'CR'));
  root.append(credits);
  const setCredits = (value: number): void => {
    amount.textContent = value.toLocaleString();
  };
  return { root, setCredits };
};

/** Search box + optional toggle chip used above facility lists (same look as the storage room search). */
export const createSearchBar = (placeholder: string, onChange: (text: string) => void) => {
  const root = htmlEl('div', 'fc-search');
  const input = htmlEl('input', 'fc-search-input') as HTMLInputElement;
  input.type = 'search';
  input.placeholder = placeholder;
  input.autocomplete = 'off';
  input.addEventListener('input', () => onChange(input.value));
  root.append(input);
  return { root, input };
};

type ChipTabsOptions<T extends string> = {
  tabs: Array<{ id: T; label: string }>;
  active: T;
  onChange: (id: T) => void;
};

/** Row of filter / mode chips. */
export const createChipTabs = <T extends string>({ tabs, active, onChange }: ChipTabsOptions<T>) => {
  const root = htmlEl('div', 'fc-tabs');
  const buttons = new Map<T, HTMLButtonElement>();
  const select = (id: T): void => {
    for (const [tabId, button] of buttons) button.classList.toggle('on', tabId === id);
  };
  for (const tab of tabs) {
    const button = htmlEl('button', 'fc-tab', tab.label);
    button.type = 'button';
    button.addEventListener('click', () => {
      select(tab.id);
      onChange(tab.id);
    });
    buttons.set(tab.id, button);
    root.append(button);
  }
  select(active);
  const setLabel = (id: T, label: string): void => {
    const button = buttons.get(id);
    if (button) button.textContent = label;
  };
  const setOn = (ids: T[]): void => {
    for (const [tabId, button] of buttons) button.classList.toggle('on', ids.includes(tabId));
  };
  return { root, setLabel, setOn };
};
